import { Download } from "@/frontend/SVGs/Download";
import { I18n } from "@/i18n/I18n";
import { ButtonParent } from "../buttons/ButtonParent";
import { File } from "@/backend/models/file";
import { useGlobalStore } from "@/frontend/store/GlobalStore";

export function DownloadFileButton(props: { file: File }) {
  const { file } = props;
  const downloadFileById = useGlobalStore(state => state.downloadFileById);

  return (
    <ButtonParent title={I18n.get('downloadFile', { fileName: file.fileName })} onClick={() => void downloadFileById(file)}><Download /></ButtonParent>
  );
}
